export default {
    getThemes(customerId) {
        return axios.get(`/customers/${customerId}/themes`)
    },
    getCustomers() {
        return axios.get('/banner/customers')
    }
}